import { AdminPartnerPrice } from '@returnmates/client-core/src/graphql/generated/api'
import { getHubs } from '@returnmates/client-core/src/selectors/hubs'
import Input from '@returnmates/ui-core/src/components/Input'
import { memo, useCallback, useMemo } from 'react'
import { useField } from 'react-final-form'
import { useSelector } from 'react-redux'

import Remove from '../../images/icons/remove'
import Select from '../../Select'
import useStyles from '../styles'

interface Props {
  price?: number
  hubId?: string
  code?: string
  onHubChange?: (val: string, hubId?: string) => void
  onPriceChange?: (val: string, hubId?: string) => void
  removePrice?: (hubId?: string) => void
}

function Price({
  price,
  hubId,
  onHubChange: onHubChangeProp,
  onPriceChange: onPriceChangeProp,
  removePrice: removePriceProp,
}: Props) {
  const classes = useStyles({})
  const hubs = useSelector(getHubs)
  const { input: prices } = useField<Array<AdminPartnerPrice>>('priceHubs')

  const currentHub = useMemo(() => hubs?.find(h => h.id === hubId), [hubs, hubId])
  const hubsSelect = useMemo(
    () =>
      hubs?.reduce(
        (acc, h) =>
          prices.value.find(p => p.hubId === h.id && p.hubId !== hubId)
            ? { ...acc }
            : { ...acc, [h.id as string]: h.name },
        {},
      ) || {},
    [hubs, hubId, prices.value],
  )

  const onHubChange = useCallback(
    e => {
      onHubChangeProp?.(e.target.value, hubId)
    },
    [onHubChangeProp, hubId],
  )

  const onPriceChange = useCallback(
    val => {
      onPriceChangeProp?.(val, hubId)
    },
    [onPriceChangeProp, hubId],
  )

  const removePrice = useCallback(() => {
    removePriceProp?.(hubId)
  }, [removePriceProp, hubId])

  return (
    <div className={classes.price}>
      <Select
        value={currentHub?.id || ''}
        onChange={onHubChange}
        values={hubsSelect}
        placeholder="Choose hub"
        className={classes.select}
      />
      <Input
        placeholder="1.5"
        classes={{
          textField: classes.input,
        }}
        onChange={onPriceChange}
        value={`${price || ''}`}
        type="number"
      />
      <Remove onClick={removePrice} className={classes.removePriceIcon} />
    </div>
  )
}

export default memo(Price)
